import { TokenParameter } from '../shared/models/tokenParameter';

export class LocalStorage {
    public get(string) {
        return localStorage.getItem(string);
    }

    public saveSport(sport: string) {
        localStorage.setItem('tnt.sport', sport);
    }

    public getSport(): string | null {
        return localStorage.getItem('tnt.sport');
    }

    /**
     * Salvar token do host
     * @param token
     */
    public saveToken(token: string) {
        localStorage.setItem('tnt.token', token);
    }

    /**
     * Buscar token do host
     */
    public getToken(): string {
        return localStorage.getItem('tnt.token');
    }

    /**
     * Limpar dados do token do host
     */
    public resetToken() {
        localStorage.removeItem('tnt.token');
    }

    /**
     * Salvar host
     * @param host
     */
    public saveHost(host: string) {
        localStorage.setItem('tnt.host', host);
    }

    /**
     * Buscar host
     */
    public getHost(): string {
        return localStorage.getItem('tnt.host');
    }

    /**
     * Salvar usuário
     */
    public saveUser(user) {
        localStorage.setItem('tnt.user', JSON.stringify(user));
    }

    /**
     * Salvar preferencias do usuario
     */
    // prettier-ignore
    public saveUserLangs(selected, available) {
        localStorage.setItem('tnt.userLangs', JSON.stringify({selected, available}));
    }

    /**
     * Salvar preferencias do usuario
     */
    public getUserLangs(): any {
        return JSON.parse(localStorage.getItem('tnt.userLangs'));
    }

    public resetLangs() {
        localStorage.removeItem('tnt.userLangs');
    }

    /**
     * Buscar usuário
     *  */
    public getUser(): any {
        return JSON.parse(localStorage.getItem('tnt.user'));
    }

    /**
     * Limpar dados do user do localstorage
     */
    public resetUser() {
        localStorage.removeItem('tnt.user');
        localStorage.removeItem('tnt.affiliationType');
    }

    /**
     * Retorna se o site personalizado está situado no Brazil
     * para fins de formatação de documentos e telefones
     */
    public isBrazil() {
        return this.getHost().includes('.com.br');
    }

    public isPickleball() {
        return this.getHost()?.includes('pickleball');
    }
}
